import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import { useAuth } from '../context/AuthContext';
import { AntragBadge } from '../components/Aufnahmeantrag';
import EmailModal from '../components/EmailModal';
import VerlaufExport from '../components/VerlaufExport';
import { hinweis } from '../components/Hinweise';

const KURS_REIHENFOLGE = ['pirat', 'seepferdchen', 'trixi', 'bronze', 'silber', 'gold'];

const KURS_INFO = {
  pirat:        { label: 'Pirat',        farbe: '#880e4f', bg: '#fce4ec', emoji: '🏴‍☠️' },
  seepferdchen: { label: 'Seepferdchen', farbe: '#0d47a1', bg: '#e3f2fd', emoji: '🐴' },
  trixi:        { label: 'Trixi',        farbe: '#1b5e20', bg: '#e8f5e9', emoji: '🌟' },
  bronze:       { label: 'Bronze',       farbe: '#e65100', bg: '#fff3e0', emoji: '🥉' },
  silber:       { label: 'Silber',       farbe: '#424242', bg: '#f5f5f5', emoji: '🥈' },
  gold:         { label: 'Gold',         farbe: '#f57f17', bg: '#fffde7', emoji: '🥇' },
};

function calcAlter(geb) {
  if (!geb) return '–';
  return Math.floor((Date.now() - new Date(geb).getTime()) / (365.25 * 24 * 3600 * 1000)) + ' J.';
}
function fmtDate(d) { return d ? new Date(d).toLocaleDateString('de-DE') : '–'; }
function fmtDateTime(d) {
  if (!d) return '–';
  return new Date(d).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

// ── Doppelter Bestätigungs-Dialog ───────────────────────────────────────────
function LoeschDialog({ dialog, onClose, onConfirm, onChange }) {
  if (!dialog) return null;
  const { schwimmer, schritt, eingabe, typ } = dialog;
  const name = `${schwimmer.vorname} ${schwimmer.nachname}`;
  const istEndgueltig = typ === 'endgueltig';

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
      zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '1rem',
    }} onClick={onClose}>
      <div style={{
        background: '#fff', borderRadius: 10, maxWidth: 440, width: '100%',
        borderTop: `4px solid #CC0000`, overflow: 'hidden',
        boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
      }} onClick={e => e.stopPropagation()}>

        {schritt === 1 && (
          <div style={{ padding: '1.5rem' }}>
            <div style={{ fontWeight: 700, fontSize: '1.05rem', marginBottom: '0.75rem', color: '#1a1e2a' }}>
              {istEndgueltig ? '⚠ Endgültig löschen?' : 'In Papierkorb verschieben?'}
            </div>
            {istEndgueltig && (
              <div style={{
                background: '#fff3cd', border: '1px solid #ffc107', borderRadius: 6,
                padding: '0.625rem 0.875rem', marginBottom: '0.875rem',
                fontSize: '0.85rem', color: '#856404', fontWeight: 600,
              }}>
                ENDGÜLTIG — diese Aktion kann NICHT rückgängig gemacht werden!
              </div>
            )}
            <p style={{ color: '#444', fontSize: '0.9rem', lineHeight: 1.6, margin: '0 0 1.25rem' }}>
              {istEndgueltig
                ? `Soll „${name}" wirklich endgültig und unwiderruflich gelöscht werden? Alle Daten inkl. Verlaufshistorie werden permanent entfernt.`
                : `Soll „${name}" in den Papierkorb verschoben werden? Der Datensatz kann danach wiederhergestellt oder endgültig gelöscht werden.`
              }
            </p>
            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
              <button className="btn btn-secondary" onClick={onClose}>Abbrechen</button>
              <button className="btn" style={{ background: '#CC0000', color: '#fff', border: 'none' }}
                onClick={() => onChange({ ...dialog, schritt: 2 })}>
                Weiter →
              </button>
            </div>
          </div>
        )}

        {schritt === 2 && (
          <div style={{ padding: '1.5rem' }}>
            <div style={{ fontWeight: 700, fontSize: '1.05rem', marginBottom: '0.75rem', color: '#1a1e2a' }}>
              {istEndgueltig ? 'Endgültige Löschung bestätigen' : 'Löschung bestätigen'}
            </div>
            <div style={{
              background: '#fff5f5', border: '1px solid #ffcdd2', borderRadius: 6,
              padding: '0.625rem 0.875rem', marginBottom: '0.875rem',
              fontSize: '0.82rem', color: '#b71c1c',
            }}>
              {istEndgueltig
                ? '⚠ Diese Aktion löscht alle Daten inkl. Kontaktperson und Verlaufshistorie ENDGÜLTIG und unwiderruflich.'
                : '⚠ Diese Aktion verschiebt alle Daten inkl. Kontaktperson und Verlaufshistorie in den Papierkorb.'
              }
            </div>
            <p style={{ color: '#444', fontSize: '0.88rem', marginBottom: '0.75rem' }}>
              Geben Sie <strong>„Löschen"</strong> ein, um{' '}
              <strong>{name}</strong>{' '}
              {istEndgueltig ? 'endgültig zu löschen' : 'in den Papierkorb zu verschieben'}:
            </p>
            <input
              type="text"
              className="form-control"
              placeholder="Löschen"
              value={eingabe}
              onChange={e => onChange({ ...dialog, eingabe: e.target.value })}
              autoFocus
              style={{ marginBottom: '1rem' }}
            />
            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
              <button className="btn btn-secondary" onClick={onClose}>Abbrechen</button>
              <button
                className="btn"
                style={{
                  background: eingabe === 'Löschen' ? '#CC0000' : '#e0e0e0',
                  color: eingabe === 'Löschen' ? '#fff' : '#999',
                  border: 'none', cursor: eingabe === 'Löschen' ? 'pointer' : 'not-allowed',
                }}
                disabled={eingabe !== 'Löschen'}
                onClick={onConfirm}
              >
                {istEndgueltig ? '✕ Endgültig löschen' : '🗑 In Papierkorb verschieben'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default function Schwimmer() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [schwimmer, setSchwimmer]           = useState([]);
  const [gruppen, setGruppen]               = useState([]);
  const [papierkorb, setPapierkorb]         = useState([]);
  const [loading, setLoading]               = useState(true);
  const [search, setSearch]                 = useState('');
  const [offeneGruppen, setOffeneGruppen]   = useState({});
  const [ehemaligeOffen, setEhemaligeOffen] = useState(false);
  const [papierkorbOffen, setPapierkorbOffen] = useState(false);
  const [loeschDialog, setLoeschDialog]     = useState(null);
  const [actionLoading, setActionLoading]   = useState(false);
  const [auffaellig, setAuffaellig]         = useState([]);
  const [nachhakenModal, setNachhakenModal] = useState(null);
  const [exportOffen, setExportOffen]       = useState(false);

  const kannLoeschen = user?.rolle === 'admin' || user?.rolle === 'schwimmadmin';

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const calls = [
        api.get('/api/admin/schwimmer'),
        api.get('/api/admin/gruppen'),
      ];
      if (kannLoeschen) {
        calls.push(api.get('/api/admin/schwimmer/papierkorb'));
        calls.push(api.get('/api/admin/anwesenheit/auffaellig'));
      }
      const [swRes, grRes, pkRes, affRes] = await Promise.all(calls);
      setSchwimmer(swRes.data);
      setGruppen(grRes.data);
      if (kannLoeschen) {
        setPapierkorb(pkRes.data);
        setAuffaellig(affRes.data);
      }
      const init = {};
      grRes.data.forEach(g => { init[g.id] = true; });
      setOffeneGruppen(init);
    } catch { /* ignoriert */ }
    finally { setLoading(false); }
  }, [kannLoeschen]);

  useEffect(() => { load(); }, [load]);

  const handleLoeschConfirm = async () => {
    if (!loeschDialog || loeschDialog.eingabe !== 'Löschen') return;
    setActionLoading(true);
    try {
      if (loeschDialog.typ === 'endgueltig') {
        await api.delete(`/api/admin/schwimmer/${loeschDialog.schwimmer.id}/endgueltig`);
      } else {
        await api.delete(`/api/admin/schwimmer/${loeschDialog.schwimmer.id}`);
      }
      setLoeschDialog(null);
      await load();
    } catch (err) {
      hinweis.fehler('Fehler: ' + (err.response?.data?.error || 'Unbekannter Fehler'));
    } finally {
      setActionLoading(false);
    }
  };

  const handleWiederherstellen = async (sw) => {
    if (!window.confirm(`„${sw.vorname} ${sw.nachname}" aus dem Papierkorb wiederherstellen?`)) return;
    try {
      await api.post(`/api/admin/schwimmer/${sw.id}/wiederherstellen`);
      await load();
    } catch (err) {
      hinweis.fehler('Fehler: ' + (err.response?.data?.error || 'Unbekannter Fehler'));
    }
  };

  // Client-seitige Suche
  const searchLower = search.toLowerCase();
  const gefiltert = schwimmer.filter(s =>
    !search ||
    `${s.vorname} ${s.nachname}`.toLowerCase().includes(searchLower) ||
    (s.kontakt_email || '').toLowerCase().includes(searchLower) ||
    (s.kontakt_name || '').toLowerCase().includes(searchLower)
  );

  const aktive    = gefiltert.filter(s => s.aktiv_im_verein);
  const ehemalige = gefiltert.filter(s => !s.aktiv_im_verein);

  const nachGruppe = {};
  aktive.forEach(s => {
    const key = s.aktuelle_gruppe_id ?? 'ohne';
    if (!nachGruppe[key]) nachGruppe[key] = [];
    nachGruppe[key].push(s);
  });

  const sortedGruppen = [...gruppen].sort((a, b) =>
    KURS_REIHENFOLGE.indexOf(a.kurs_typ) - KURS_REIHENFOLGE.indexOf(b.kurs_typ)
  );

  const toggleGruppe = id => setOffeneGruppen(p => ({ ...p, [id]: !p[id] }));

  // ── Schwimmer-Zeile ─────────────────────────────────────────────────────────
  const SchwimmerZeile = ({ s, zeigeDatum }) => (
    <tr style={{ cursor: 'pointer' }} onClick={() => navigate(`/schwimmer/${s.id}`)}>
      <td>
        <div style={{ fontWeight: 600 }}>{s.vorname} {s.nachname}</div>
        <AntragBadge status={s.aufnahmeantrag_status} ueberfaellig={s.aufnahmeantrag_ueberfaellig} trainings={s.aufnahmeantrag_trainings} />
      </td>
      <td style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>{calcAlter(s.geburtsdatum)}</td>
      <td style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>
        {zeigeDatum ? fmtDate(s[zeigeDatum]) : '–'}
      </td>
      <td style={{ fontSize: '0.8rem' }}>
        <div>{s.kontakt_name}</div>
        <div style={{ color: 'var(--text-muted)', fontSize: '0.75rem' }}>{s.kontakt_email}</div>
      </td>
      {kannLoeschen && (
        <td style={{ width: 40, textAlign: 'center' }}>
          <button
            title="In Papierkorb verschieben"
            onClick={e => {
              e.stopPropagation();
              setLoeschDialog({ schwimmer: s, schritt: 1, eingabe: '', typ: 'papierkorb' });
            }}
            style={{
              background: 'none', border: '1px solid #ffcdd2', borderRadius: 6,
              color: '#c62828', cursor: 'pointer', padding: '0.2rem 0.4rem',
              fontSize: '0.85rem', lineHeight: 1,
            }}
          >
            🗑
          </button>
        </td>
      )}
    </tr>
  );

  // ── Gruppen-Header ───────────────────────────────────────────────────────────
  const GruppeHeader = ({ gruppe, anzahl, offen, onClick }) => {
    const info = KURS_INFO[gruppe.kurs_typ] || {};
    return (
      <div onClick={onClick} style={{
        display: 'flex', alignItems: 'center', gap: '0.75rem',
        padding: '0.875rem 1.25rem', cursor: 'pointer', userSelect: 'none',
        background: info.bg || '#f0f4f8',
        borderRadius: offen ? '8px 8px 0 0' : 8,
        borderBottom: offen ? `1px solid ${info.farbe}30` : 'none',
      }}>
        <span style={{ fontSize: '1.25rem' }}>{info.emoji}</span>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 700, color: info.farbe || 'var(--text)' }}>{gruppe.name}</div>
          <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: 2 }}>
            {info.label}
            {gruppe.trainer   && ` · ${gruppe.trainer}`}
            {gruppe.wochentag && ` · ${gruppe.wochentag}`}
            {gruppe.uhrzeit   && ` ${gruppe.uhrzeit}`}
          </div>
        </div>
        <span style={{ fontWeight: 700, color: info.farbe, fontSize: '0.85rem', whiteSpace: 'nowrap' }}>
          {anzahl} Schwimmer
        </span>
        <span style={{ color: 'var(--text-muted)', fontSize: '0.75rem', marginLeft: 4 }}>
          {offen ? '▲' : '▼'}
        </span>
      </div>
    );
  };

  // Spaltenheader-Hilfsfunktion mit optionaler Löschen-Spalte
  const TheadZeile = ({ cols }) => (
    <thead>
      <tr>
        {cols.map(c => <th key={c}>{c}</th>)}
        {kannLoeschen && <th style={{ width: 40 }} />}
      </tr>
    </thead>
  );

  return (
    <div>
      <div className="page-header">
        <h2 className="page-title">
          Schwimmer{' '}
          <span style={{ color: 'var(--text-muted)', fontWeight: 400, fontSize: '1rem' }}>
            ({aktive.length} aktiv
            {ehemalige.length > 0 && `, ${ehemalige.length} ehemalig`})
          </span>
        </h2>
        {kannLoeschen && (
          <button className="btn btn-secondary btn-sm" onClick={() => setExportOffen(true)}>📊 Verlauf exportieren</button>
        )}
      </div>

      {exportOffen && <VerlaufExport onClose={() => setExportOffen(false)} />}

      <div className="card" style={{ marginBottom: '1rem', padding: '0.75rem 1rem' }}>
        <input type="search" className="search-input"
          placeholder="Suche nach Name, E-Mail, Kontakt…"
          value={search} onChange={e => setSearch(e.target.value)}
          style={{ width: '100%', maxWidth: 400 }} />
      </div>

      {/* ── Nachhaken empfohlen ────────────────────────────────────────────── */}
      {kannLoeschen && auffaellig.length > 0 && (
        <div className="card" style={{
          marginBottom: '1rem', borderLeft: '3px solid #f57f17', background: '#fffdf5',
        }}>
          <div style={{ padding: '0.875rem 1rem 0.5rem', display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
            <span style={{ fontSize: '1.1rem' }}>⚠</span>
            <div>
              <div style={{ fontWeight: 700, color: '#e65100', fontSize: '0.9rem' }}>Nachhaken empfohlen</div>
              <div style={{ fontSize: '0.73rem', color: 'var(--text-muted)' }}>
                {auffaellig.length} {auffaellig.length === 1 ? 'Schwimmer fehlt' : 'Schwimmer fehlen'} mehrfach in Folge unentschuldigt
              </div>
            </div>
          </div>
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Gruppe</th>
                  <th>Fehlt in Folge</th>
                  <th>Zuletzt anwesend</th>
                  <th>Kontakt</th>
                  <th style={{ width: 40 }} />
                </tr>
              </thead>
              <tbody>
                {auffaellig.map(a => (
                  <tr key={a.schwimmer_id} style={{ cursor: 'pointer' }} onClick={() => navigate(`/schwimmer/${a.schwimmer_id}`)}>
                    <td style={{ fontWeight: 600 }}>{a.name}</td>
                    <td style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>{a.gruppe_name || '–'}</td>
                    <td>
                      <span style={{
                        padding: '2px 9px', borderRadius: 12, fontWeight: 700, fontSize: '0.8rem',
                        background: '#ffebee', color: '#c62828',
                      }}>
                        {a.unentschuldigt_in_folge}×
                      </span>
                    </td>
                    <td style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>{fmtDate(a.letzter_anwesend_datum)}</td>
                    <td style={{ fontSize: '0.8rem' }}>
                      <div>{a.kontakt_name}</div>
                      <div style={{ color: 'var(--text-muted)', fontSize: '0.75rem' }}>{a.kontakt_email}</div>
                    </td>
                    <td>
                      {a.kontakt_email && (
                        <button
                          className="btn btn-secondary btn-sm"
                          style={{ fontSize: '0.78rem', padding: '0.25rem 0.6rem', whiteSpace: 'nowrap' }}
                          onClick={e => { e.stopPropagation(); setNachhakenModal(a); }}
                        >
                          ✉ Nachfragen
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {loading ? (
        <div style={{ textAlign: 'center', padding: '3rem' }}>
          <div className="loading-spinner" style={{ margin: '0 auto' }} />
        </div>
      ) : (
        <>
          {/* ── Gruppen-Sektionen ──────────────────────────────────────────── */}
          {sortedGruppen.map(gruppe => {
            const mitglieder = nachGruppe[gruppe.id] || [];
            if (mitglieder.length === 0) return null;
            const offen = offeneGruppen[gruppe.id] !== false;
            const info = KURS_INFO[gruppe.kurs_typ] || {};
            return (
              <div key={gruppe.id} style={{
                marginBottom: '1rem',
                border: `1px solid ${info.farbe ? info.farbe + '30' : '#e0e0e0'}`,
                borderRadius: 8, overflow: 'hidden',
              }}>
                <GruppeHeader
                  gruppe={gruppe}
                  anzahl={mitglieder.length}
                  offen={offen}
                  onClick={() => toggleGruppe(gruppe.id)}
                />
                {offen && (
                  <div className="table-wrap">
                    <table>
                      <TheadZeile cols={['Name', 'Alter', 'In Gruppe seit', 'Kontakt']} />
                      <tbody>
                        {mitglieder.map(s => (
                          <SchwimmerZeile key={s.id} s={s} zeigeDatum="gruppe_seit" />
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            );
          })}

          {/* ── Aktive ohne Gruppe ─────────────────────────────────────────── */}
          {(nachGruppe['ohne'] || []).length > 0 && (
            <div style={{ marginBottom: '1rem', border: '1px solid #e0e0e0', borderRadius: 8, overflow: 'hidden' }}>
              <div style={{
                padding: '0.875rem 1.25rem', background: '#fafafa',
                fontWeight: 700, color: 'var(--text-muted)', fontSize: '0.9rem',
              }}>
                Ohne Gruppe ({nachGruppe['ohne'].length})
              </div>
              <div className="table-wrap">
                <table>
                  <TheadZeile cols={['Name', 'Alter', 'Im Verein seit', 'Kontakt']} />
                  <tbody>
                    {nachGruppe['ohne'].map(s => (
                      <SchwimmerZeile key={s.id} s={s} zeigeDatum="created_at" />
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* ── Leer-Zustand ───────────────────────────────────────────────── */}
          {aktive.length === 0 && (
            <div className="card">
              <div className="empty-state">
                <div className="empty-state-icon">🏊</div>
                <div className="empty-state-text">
                  {search ? 'Keine aktiven Schwimmer gefunden' : 'Noch keine aktiven Schwimmer'}
                </div>
              </div>
            </div>
          )}

          {/* ── Ehemalige Mitglieder ───────────────────────────────────────── */}
          <div style={{ marginBottom: '1rem', border: '1px solid #e0e0e0', borderRadius: 8, overflow: 'hidden' }}>
            <div onClick={() => setEhemaligeOffen(!ehemaligeOffen)} style={{
              display: 'flex', alignItems: 'center', gap: '0.75rem',
              padding: '0.875rem 1.25rem', cursor: 'pointer', userSelect: 'none',
              background: '#f5f5f5',
              borderRadius: ehemaligeOffen ? '8px 8px 0 0' : 8,
            }}>
              <span style={{ fontSize: '1.25rem' }}>🎓</span>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 700, color: '#616161' }}>Ehemalige Mitglieder</div>
                <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: 2 }}>
                  Ausgetreten oder Ausbildung abgeschlossen
                </div>
              </div>
              <span style={{ fontWeight: 700, color: '#757575', fontSize: '0.85rem' }}>
                {ehemalige.length} {ehemalige.length === 1 ? 'Person' : 'Personen'}
              </span>
              <span style={{ color: 'var(--text-muted)', fontSize: '0.75rem', marginLeft: 4 }}>
                {ehemaligeOffen ? '▲' : '▼'}
              </span>
            </div>
            {ehemaligeOffen && (
              ehemalige.length === 0 ? (
                <div style={{ padding: '1.5rem', textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.9rem' }}>
                  {search ? 'Keine ehemaligen Mitglieder gefunden' : 'Noch keine ehemaligen Mitglieder'}
                </div>
              ) : (
                <div className="table-wrap">
                  <table>
                    <TheadZeile cols={['Name', 'Alter', 'Vereinsaustritt', 'Kontakt']} />
                    <tbody>
                      {ehemalige.map(s => (
                        <SchwimmerZeile key={s.id} s={s} zeigeDatum="vereinsaustritt_datum" />
                      ))}
                    </tbody>
                  </table>
                </div>
              )
            )}
          </div>

          {/* ── Papierkorb ─────────────────────────────────────────────────── */}
          {kannLoeschen && (
            <div style={{
              border: '1px solid #ffcdd2', borderLeft: '3px solid #CC0000',
              borderRadius: 8, overflow: 'hidden',
            }}>
              <div onClick={() => setPapierkorbOffen(!papierkorbOffen)} style={{
                display: 'flex', alignItems: 'center', gap: '0.75rem',
                padding: '0.875rem 1.25rem', cursor: 'pointer', userSelect: 'none',
                background: '#fff5f5',
                borderRadius: papierkorbOffen ? '8px 8px 0 0' : 8,
              }}>
                <span style={{ fontSize: '1.1rem' }}>🗑</span>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, color: '#b71c1c', fontSize: '0.9rem' }}>Papierkorb</div>
                  <div style={{ fontSize: '0.73rem', color: '#c62828', marginTop: 2 }}>
                    Zur Wiederherstellung oder endgültigen Löschung
                  </div>
                </div>
                <span style={{ fontWeight: 700, color: '#c62828', fontSize: '0.85rem' }}>
                  {papierkorb.length} {papierkorb.length === 1 ? 'Eintrag' : 'Einträge'}
                </span>
                <span style={{ color: '#e57373', fontSize: '0.75rem', marginLeft: 4 }}>
                  {papierkorbOffen ? '▲' : '▼'}
                </span>
              </div>

              {papierkorbOffen && (
                papierkorb.length === 0 ? (
                  <div style={{ padding: '1.5rem', textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.9rem', background: '#fff5f5' }}>
                    Papierkorb ist leer
                  </div>
                ) : (
                  <div className="table-wrap" style={{ background: '#fff5f5' }}>
                    <table>
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Geburtsdatum</th>
                          <th>Kontakt</th>
                          <th>In Papierkorb seit</th>
                          <th>Verschoben von</th>
                          <th>Aktionen</th>
                        </tr>
                      </thead>
                      <tbody>
                        {papierkorb.map(s => (
                          <tr key={s.id}>
                            <td style={{ fontWeight: 600 }}>{s.vorname} {s.nachname}</td>
                            <td style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>{fmtDate(s.geburtsdatum)}</td>
                            <td style={{ fontSize: '0.8rem' }}>
                              <div>{s.kontakt_name}</div>
                              <div style={{ color: 'var(--text-muted)', fontSize: '0.75rem' }}>{s.kontakt_email}</div>
                            </td>
                            <td style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>{fmtDateTime(s.papierkorb_am)}</td>
                            <td style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>{s.papierkorb_von_name || '–'}</td>
                            <td>
                              <div style={{ display: 'flex', gap: '0.4rem', flexWrap: 'wrap' }}>
                                <button
                                  className="btn btn-secondary btn-sm"
                                  style={{ fontSize: '0.78rem', padding: '0.25rem 0.6rem' }}
                                  onClick={() => handleWiederherstellen(s)}
                                >
                                  ↩ Wiederherstellen
                                </button>
                                <button
                                  className="btn btn-sm"
                                  style={{
                                    fontSize: '0.78rem', padding: '0.25rem 0.6rem',
                                    background: '#b71c1c', color: '#fff', border: 'none',
                                  }}
                                  onClick={() => setLoeschDialog({ schwimmer: s, schritt: 1, eingabe: '', typ: 'endgueltig' })}
                                >
                                  ✕ Endgültig löschen
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )
              )}
            </div>
          )}
        </>
      )}

      <LoeschDialog
        dialog={loeschDialog}
        onClose={() => setLoeschDialog(null)}
        onConfirm={handleLoeschConfirm}
        onChange={setLoeschDialog}
      />

      {nachhakenModal && (
        <EmailModal
          an={nachhakenModal.kontakt_email}
          anzeigeName={nachhakenModal.kontakt_name}
          apiPfad={`/api/admin/schwimmer/${nachhakenModal.schwimmer_id}/email`}
          initialBetreff={`Nachfrage zum Training – ${nachhakenModal.name.split(' ')[0]}`}
          initialNachricht={
            `Hallo${nachhakenModal.kontakt_name ? ' ' + nachhakenModal.kontakt_name : ''},\n\n` +
            `uns ist aufgefallen, dass ${nachhakenModal.name} in letzter Zeit mehrfach nicht beim Training war. ` +
            `Wir wollten kurz nachfragen, ob alles in Ordnung ist und weiterhin Interesse am Training besteht.\n\n` +
            `Über eine kurze Rückmeldung würden wir uns freuen.\n\n` +
            `Sportliche Grüße`
          }
          onClose={() => setNachhakenModal(null)}
          onSent={() => setNachhakenModal(null)}
        />
      )}
    </div>
  );
}
